import type * as React from 'react';

/**
 * Available sizes for ScoreSticker v2.
 * - Lg: 106px, with optional diff badge
 * - Sm: 64px (default), no diff
 * - Xs: 40px, no diff
 * - Xxs: 32px, no diff
 */
enum ScoreStickerV2Size {
  Lg = 'lg',
  Sm = 'sm',
  Xs = 'xs',
  Xxs = 'xxs',
}

interface ScoreStickerV2Props extends React.HTMLAttributes<HTMLDivElement> {
  /** The score value to display (0-100). Null renders N/A state. */
  score: number | null;
  /** Score difference (positive = up arrow, negative = down arrow). Only rendered for Lg. */
  scoreDiff?: number | null;
  /**
   * The size of the sticker.
   * @default 'sm'
   */
  size?: ScoreStickerV2Size;
  /** Whether the component is in loading state (renders a skeleton). */
  isLoading?: boolean;
  /** Whether the component is in processing state (opacity 40%). */
  isProcessing?: boolean;
  /** Whether the component is in disabled state (pale text on transparent bg). */
  isDisabled?: boolean;
  /**
   * Whether the sticker represents an informational asset. Renders a text-lines
   * icon on a neutral gray background instead of a score, ignoring `score` and
   * `scoreDiff`. Takes precedence over the score/N-A rendering.
   */
  isInformational?: boolean;
  /** Ref forwarded to the root element. */
  ref?: React.Ref<HTMLDivElement>;
}

export { ScoreStickerV2Size };
export type { ScoreStickerV2Props };
